import React from 'react'
import { useTranslations } from 'next-intl'

import { FullPageLoader } from './fullPageLoader'

interface FullPageLoaderWrapperProps {
    message?: React.ReactNode
    hideBackdrop?: boolean
}

const FullPageLoaderWrapper: React.FC<FullPageLoaderWrapperProps> = ({
    message,
    hideBackdrop = false
}) => {
    const t = useTranslations('common')
    const displayMessage = message || t('loading')

    return <FullPageLoader message={displayMessage} hideBackdrop={hideBackdrop} />
}

export { FullPageLoaderWrapper }
export default FullPageLoaderWrapper

